"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnsViewComp = exports.testViewCompPropsCreator = exports.ViewComp = exports.BaseAnsComp = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var __1 = require("../..");
var DummyClass = /** @class */ (function () {
    function DummyClass() {
    }
    return DummyClass;
}());
// this is a hack so lack of react doesn't cause this file to explode in runtime
var Comp = React.PureComponent || DummyClass;
var BaseAnsComp = /** @class */ (function (_super) {
    tslib_1.__extends(BaseAnsComp, _super);
    function BaseAnsComp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BaseAnsComp;
}(Comp));
exports.BaseAnsComp = BaseAnsComp;
var ViewComp = /** @class */ (function (_super) {
    tslib_1.__extends(ViewComp, _super);
    function ViewComp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ViewComp;
}(BaseAnsComp));
exports.ViewComp = ViewComp;
var testViewCompPropsCreator = function (defaultsOrFn, tSource) {
    if (tSource === void 0) { tSource = {}; }
    var t = (0, __1.createTranslateFn)(function (k) { return tSource[k]; });
    var defaults = typeof defaultsOrFn === 'function' ? defaultsOrFn() : defaultsOrFn;
    return (0, __1.testDataCreator)(function () { return (tslib_1.__assign({ t: t }, defaults)); });
};
exports.testViewCompPropsCreator = testViewCompPropsCreator;
var AnsViewComp = /** @class */ (function (_super) {
    tslib_1.__extends(AnsViewComp, _super);
    function AnsViewComp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AnsViewComp;
}(ViewComp));
exports.AnsViewComp = AnsViewComp;
//# sourceMappingURL=index.js.map